import * as ng from 'angular';

import { Prize } from '../shared/prize.model';
import { ApiHelperService } from '../../../shared';

export class PrizesApiService {
   apiUri:string;

   constructor(
      eventId:number,
      private apiHelper:ApiHelperService
   ) {
      this.apiUri = 'events/' + eventId + '/prizes';
   }

   create(prize:Prize) {
      return this.apiHelper.post(this.apiUri, prize);
   }

   update(prize:Prize) {
      return this.apiHelper.post(`${this.apiUri}/${prize.id}`, prize);
   }

   remove(prize:Prize) {
      return this.apiHelper.del(`${this.apiUri}/${prize.id}`);
   }

   list():ng.IPromise<Prize[]> {
      return this.apiHelper.get(this.apiUri);
   }

   simulate(iterations:number):ng.IPromise<{name:string,count:number}[]> {
      return this.apiHelper.get(`${this.apiUri}/simulate`, { iterations: iterations });
   }
}

export type PrizesApiFactory = (eventId:number) => PrizesApiService;

prizesApiFactory.$inject = ['apiHelper'];
function prizesApiFactory(apiHelper:ApiHelperService):PrizesApiFactory {
   return function(eventId:number) {
      return new PrizesApiService(eventId, apiHelper);
   }
}

ng.module('e360')
   .factory('prizesApiFactory', prizesApiFactory);
